import { v4 as uuidv4 } from "uuid";

export function printToast({ severity = "success", summary = "", detail = "" }) {
  let maiorMessage = summary.length > detail.length ? summary : detail;
  let messageLength = maiorMessage.split(" ").length;
  let life = (messageLength * 60000) / 150;
  window.$toast.current.show({ severity, summary, detail, life });
}

export const pageableApi = {
  content: [],
  totalElements: 0
}

export const optionsAtivoInativo = [
  { name: "Inativo", code: 0 },
  { name: "Ativo", code: 1 },
];

export function classNames(parm) {
  let classes = "";

  for (let key of Object.keys(parm)) {
    if (parm[key]) {
      classes += ` ${key}`;
    }
  }

  return classes;
}

export const isFormFieldValid = (name, formik) => {
  let value = formik.touched;

  if (name.split(".").length > 1 && Object.keys(value).length > 0) {
    let array = name.split(".");
    // let qtd = array.length
    for (let nome of array) {
      value = value[nome] ? value[nome] : undefined;
    }
  } else {
    value = formik.touched[name];
  }

  return value && formik.errors[name];
};

export const getFormErrorMessage = (name, formik) => {
  return isFormFieldValid(name, formik) && <small className="p-error">{formik.errors[name]}</small>;
};

export const summaryCriacaoSucessoPadrao = "Criação concluída";
export const detailCriacaoSucessoPadrao = "O registro foi inserido com sucesso";

export const summaryAlteracaoSucessoPadrao = "Alteração concluída";
export const detailAlteracaoSucessoPadrao = "O registro foi alterado com sucesso";

export const summaryExclusaoSucessoPadrao = "Exclusão concluída";
export const detailExclusaoSucessoPadrao = "O registro foi excluído com sucesso";

export const getUUID = () => {
  return uuidv4();
};

export const formatoContatos = ({ telefones }) => {
  telefones = telefones.split(" ");
  let telefonesAjustado = [];
  if (telefones.length > 1) {
    for (let i = 0; i < telefones.length; i++) {
      if (telefones[i] !== "") {
        if (telefones[i].length === 11) {
          telefonesAjustado.push(telefones[i].replace(/(\d{2})?(\d{5})?(\d{4})/, "($1)$2-$3"));
          telefonesAjustado.push(<br />);
        } else if (telefones[i].length === 12) {
          telefonesAjustado.push(telefones[i].replace("0", "").replace(/(\d{2})?(\d{5})?(\d{4})/, "($1)$2-$3"));
          telefonesAjustado.push(<br />);
        } else {
          telefonesAjustado.push(telefones[i].replace(/(\d{2})?(\d{4})?(\d{4})/, "($1)$2-$3"));
          telefonesAjustado.push(<br />);
        }
      }
    }
  }
  if (telefonesAjustado !== "") {
    return telefonesAjustado;
  } else {
    return telefones;
  }
};

export const pt = {
  firstDayOfWeek: 0,
  dayNames: ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"],
  dayNamesShort: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  dayNamesMin: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
  monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
  monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Sep", "Out", "Nov", "Dec"],
  today: "Hoje",
  clear: "Claro",
};
